import types from "../actionTypes";

export default (
  state = {
    reports: [],
    userPermissions: [],
    userRoles: [],
    allAuthUsers: [],
    authUser: {},
    isUserSet: false,
    totalRecord: 0,
    isUserDelete: false,
    companyList: [],
    selectedCompany: null,
    domainList: [],
    domainFlag: false,
    departmentList: [],
    backupUserList: [],
    backupUserFlag: false,
    companyServices: undefined,
    isBackupAssigned: false,
    successMessageForBackupUserAssigned: "",
    openSimpleModalForTermiantion: false,
    regionList: [],
    levelItem: [],
    masterReport: [],
    selectedDomainUsers:[],
    isSelectedUserLoaded:false,
    confirmationValue:false,
    userAccessReport: [],
    reportModules:[]
  },
  action
) => {
  switch (action.type) {
    case types.SET_USER_PERMISSIONS:
      return Object.assign({}, state, { userPermissions: action.userPermissions });
    case types.SET_MY_REPORT:
      return Object.assign({}, state, { userAccessReport: action.data });
    case types.SET_REPORTS_DETAILS:
      return Object.assign({}, state, { reports: action.data });
    case types.SET_REPORTS:
      return Object.assign({}, state, { masterReport: action.data });
    case types.SET_LEVEL_ITEM:
      return Object.assign({}, state, { levelItem: action.data });
    case types.SET_USER_ROLES:
      return Object.assign({}, state, { userRoles: action.userRoles });
    case types.SET_AUTH_USERS:
      return Object.assign({}, state, { allAuthUsers: action.allAuthUsers });
    case types.SET_AUTH_USER:
      return Object.assign({}, state, { authUser: action.authUser });
    case types.IS_USER_SET:
      return Object.assign({}, state, { isUserSet: action.isUserSet });
    case types.SET_TOTAL_RECORD_OF_USER_LIST:
      return Object.assign({}, state, { totalRecord: action.totalRecord });
    case types.SET_IS_USER_DELETE:
      return Object.assign({}, state, { isUserDelete: action.isUserDelete });
    case types.SET_COMPANY_LIST:
      return Object.assign({}, state, { companyList: action.companyList });
    case types.SET_SELECTED_COMPANY:
      return Object.assign({}, state, { selectedCompany: action.selectedCompany });
    case types.SET_DOMAIN_LIST:
      return Object.assign({}, state, { domainList: action.domainList });
    case types.SET_DOMAIN_FLAG:
      return Object.assign({}, state, { domainFlag: action.domainFlag });
    case types.SET_DEPARTMENT_LIST:
      return Object.assign({}, state, { departmentList: action.departmentList });
    case types.SET_REGION_LIST:
      return Object.assign({}, state, { regionList: action.regionList });
    case types.SET_BACKUP_USERS:
      return Object.assign({}, state, { backupUserList: action.backupUserList });
    case types.SET_BACKUP_USERS_FLAG:
      return Object.assign({}, state, { backupUserFlag: action.backupUserFlag });
    case types.SET_COMPANY_SERVICES:
      return Object.assign({}, state, { companyServices: action.companyServices });
    case types.SET_ISBACKUP_ASSIGNED:
      return Object.assign({}, state, { isBackupAssigned: action.isBackupAssigned });
    case types.SET_SUCCESS_MESSAGE_FOR_BACKUP_USER_ASSIGNED:
      return Object.assign({}, state, { successMessageForBackupUserAssigned: action.successMessageForBackupUserAssigned });
    case types.OPEN_SIMPLE_MODAL_FOR_TERMINATION:
      return Object.assign({}, state, { openSimpleModalForTermiantion: action.openSimpleModalForTermiantion });
    case types.SET_SELECTED_DOMAIN_VALUES:
      return Object.assign({}, state, { selectedDomainUsers: action.selectedDomainUsers,isSelectedUserLoaded:action.isSelectedUserLoaded,confirmationValue:action.confirmationValue });
    case types.RESET_SELECTED_DOMAIN_VALUES:
      return Object.assign({}, state, { isSelectedUserLoaded:action.isSelectedUserLoaded,confirmationValue:action.confirmationValue });
    case types.SET_REPORT_MODULES:
      return Object.assign({}, state, { reportModules:action.reportModules });
    default:
      return state;
  }
};
